import { EllipsisText } from "@maxhub/max-ui"

const longText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."

export const EllipsisTextExample = {
    title: 'EllipsisText',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: longText,
        },
        {
            name: 'maxLines',
            label: 'maxLines',
            type: 'text',
            tsType: 'number',
            default: "1",
        },
    ],

    Preview({ props }){
        const { children, maxLines, ...rest } = props
        return (
            <EllipsisText maxLines={Number(maxLines) || 1} {...rest}>
                {children || longText}
            </EllipsisText>
        )
    },

    getCode(){
        return `<EllipsisText maxLines={1}>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
</EllipsisText>`
    }

}